


















import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'TaskSortAmountIcon' })
export default class TaskSortAmountIcon extends Vue {}
